import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { headerEmpresa } from '../helpers/headerEmpresa';
import { getEmpresa } from '../../services/empresaService';


async function VendasPorFinalizadora(salesData) {

  function converterDataIsoParaBr(dataIso) {
    const data = new Date(dataIso);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  // ✅ Busca dados da empresa
  const empresa = await getEmpresa();

  salesData = Array.isArray(salesData) ? salesData : [];

  // 🔹 Agrupamento por finalizadora
  const groupedSalesData = salesData.reduce((acc, sale) => {
    if (!sale || !sale.FINALIZADORA) return acc;

    const finalizadora = sale.FINALIZADORA;

    if (!acc[finalizadora]) {
      acc[finalizadora] = {
        itens: [],
        total: 0,
      };
    }

    acc[finalizadora].itens.push(sale);
    acc[finalizadora].total += Number(sale.RECEBIDO ?? 0);

    return acc;
  }, {});

  const totalGeral = Object.values(groupedSalesData)
    .reduce((sum, f) => sum + f.total, 0);

  const docDefinition = {
    pageSize: 'A4',

    // 🔹 margem maior por causa do header global
    pageMargins: [20, 60, 20, 40],

    // ✅ Cabeçalho padrão
    header: headerEmpresa(empresa),

    content: [
      {
        text: 'Relatório de Vendas por Finalizadora',
        style: 'header',
        margin: [0, 10, 0, 5],
      },
      {
        text: 'Relatório detalhado das vendas agrupadas por finalizadora.',
        style: 'subheader',
        margin: [0, 0, 0, 15],
      },
    ],

    styles: {
      header: {
        fontSize: 20,
        bold: true,
        alignment: 'center',
      },
      subheader: {
        fontSize: 12,
        italics: true,
        alignment: 'center',
      },
      sectionTitle: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        fillColor: '#f0f0f0',
      },
      tableBody: {
        fontSize: 9,
      },
      footerTotal: {
        fontSize: 12,
        bold: true,
        alignment: 'right',
        margin: [0, 15, 0, 0],
      },
    },
  };

  // 🔹 Conteúdo por finalizadora
  Object.entries(groupedSalesData).forEach(([finalizadora, data]) => {
    docDefinition.content.push(
      { text: `Finalizadora: ${finalizadora}`, style: 'sectionTitle' },
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', 80],
          body: [
            [
              { text: 'Documento', style: 'tableHeader' },
              { text: 'Caixa', style: 'tableHeader' },
              { text: 'Data', style: 'tableHeader' },
              { text: 'Valor', style: 'tableHeader', alignment: 'right' },
            ],
            ...data.itens.map(sale => ([
              sale.DOCUMENTO ?? 'N/A',
              sale.CAIXA ?? 'N/A',
              converterDataIsoParaBr(sale.DATA) ?? 'N/A',
              {
                text: `R$ ${Number(sale.RECEBIDO ?? 0).toFixed(2)}`,
                alignment: 'right',
              },
            ])),
          ],
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 5],
      },
      {
        text: `Total da Finalizadora: R$ ${data.total.toFixed(2)}`,
        alignment: 'right',
        bold: true,
        margin: [0, 0, 0, 10],
      }
    );
  });

  // 🔹 Total geral
  docDefinition.content.push({
    text: `Total Geral: R$ ${totalGeral.toFixed(2)}`,
    style: 'footerTotal',
  });

  pdfMake.createPdf(docDefinition).open();
}

export default VendasPorFinalizadora;




